import { render, staticRenderFns } from "./DagInfo.vue?vue&type=template&id=098ff295&scoped=true&"
import script from "./DagInfo.vue?vue&type=script&lang=js&"
export * from "./DagInfo.vue?vue&type=script&lang=js&"
import style0 from "./DagInfo.vue?vue&type=style&index=0&id=098ff295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098ff295",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
